import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

interface HeaderContextType {
    title: string;
    setTitle: (title: string) => void;
    resetTitle: () => void;
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export const HeaderProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [title, setTitle] = useState<string>('CompassAI');

    const resetTitle = () => setTitle('CompassAI');

    return (
        <HeaderContext.Provider value={{ title, setTitle, resetTitle }}>
            {children}
        </HeaderContext.Provider>
    );
};

export const useHeader = () => {
    const context = useContext(HeaderContext);
    if (context === undefined) {
        throw new Error('useHeader must be used within a HeaderProvider');
    }
    return context;
};
